import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

function Title({ children }) {
  return (
    <Typography component="h2" variant="h6" color="primary" sx={{ display: 'flex', alignItems: 'center' }} gutterBottom>
      {children}
    </Typography>
  );
}

Title.propTypes = {
  children: PropTypes.node,
};

Title.defaultProps = {
  children: null,
};

export default Title;
